import React from 'react';
import { element, string, oneOfType, arrayOf, node } from 'prop-types';
import { Container } from './message-box.styles';

const MessageBox = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(Container, null, children);
};

process.env.NODE_ENV !== "production" ? MessageBox.propTypes = {
  children: oneOfType([element, string, arrayOf(element), node])
} : void 0;
MessageBox.defaultProps = {
  children: undefined
};
export default MessageBox;